<template>
  <div>
    <div class="sayfahead tek">
      <h1>Kullanıcı İşlemleri</h1>
      <el-button-group class="float-right YeniBtn">
        <el-button type="primary" size="small" @click="YeniBtn">Kullanıcı Ekle
        </el-button>
      </el-button-group>

    </div>
    <div class="icerik">
      <el-table
        v-if="Liste"
        :data="Liste.filter(data => !search || data.AdSoyad.toLowerCase().includes(search.toLowerCase()) || data.Email.toLowerCase().includes(search.toLowerCase()))"
        :default-sort="{prop: 'AdSoyad', order: 'ascending'}"
        class="golgetable">

        <el-table-column
          label="Ad Soyad"
          prop="AdSoyad">
        </el-table-column>
        <el-table-column
          label="Email"
          prop="Email"
          width="300">
        </el-table-column>
        <el-table-column
          label="Telefon"
          prop="Telefon"
          width="120">
        </el-table-column>
        <el-table-column
          label="Durum"
          prop="DurumText"
          width="100">
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="medium"
              :placeholder="Arama"/>
          </template>
          <template slot-scope="scope">
            <el-button-group>
              <el-tooltip class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                          placement="top-start">
                <el-button
                  size="mini"
                  type="primary"
                  icon="flaticon2-edit"
                  @click="DuzenleBtn(scope.row)">
                </el-button>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <FormModal :data="FormData" :ModalOlayi="ModalOlayi" :Baslik="Baslik"
                 @ModalOlayi="SayfaYukle"></FormModal>

    </div>
  </div>
</template>

<script>
  import FormModal from "../../components/Pack/Kulanici/FormModal";

  export default {
    components: {FormModal},
    data() {
      return {
        ModalOlayi: false,
        Baslik: null,
        Liste: [],
        FormData: {
          AdSoyad: null,
          Email: null,
          Telefon: null,
          durum: null,
          disabled: false,
          span: 8,

        },
        search: '',
        SeciliBina: null,
        Arama: 'Arama yapın',
        Sayfa: {
          ButtonAdi: 'Kulanıcı Ekle',
          DuzenleAdi: 'Düzenle',
          SilAdi: 'Pasif',
          Button: null,
          Adi: 'Kullanıcı Detay',
          Menu: [],
          MenuDisplay: null
        },
      }
    },
    methods: {
      SayfaYukle() {
        this.ModalOlayi = false;
        this.$store.dispatch("Get", {
          path: 'kullanici/l/'
        })
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })
      },
      YeniBtn() {
        this.ModalOlayi = true;
        this.Baslik = 'Kullanıcı Ekle';
        this.FormData = {
          AdSoyad: null,
          Email: null,
          Telefon: null,
          durum: null,
          disabled: false,
          span: 8,

        }
      },
      DuzenleBtn(Veri) {
        this.Baslik = Veri.AdSoyad + ' Düzenle';
        this.ModalOlayi = true;
        Veri.span = 6;
        Veri.disabled = true;
        this.FormData = Veri

      },
    },
    mounted() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Kullanici/index.vue